// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";

var unchecked_checkbox = PricingDashboardAssetsManager.getImage("unchecked-checkbox.svg");

var checked_checkbox = PricingDashboardAssetsManager.getImage("checked-checkbox.svg");

PricingDashboardAssetsManager.getImage("simple-modification-icon.svg");

function RoundInputCheckbox(Props) {
  var is_checked = Props.is_checked;
  var on_click = Props.on_click;
  return React.createElement("img", {
              className: "c-round-checkbox",
              src: is_checked ? checked_checkbox : unchecked_checkbox,
              onClick: (function (param) {
                  return Curry._1(on_click, undefined);
                })
            });
}

var make = RoundInputCheckbox;

export {
  unchecked_checkbox ,
  checked_checkbox ,
  make ,
  
}
/* unchecked_checkbox Not a pure module */
